import React, { useState, useEffect } from 'react';
import { Wrench } from 'lucide-react';
import { API_URL } from '../config';
const POLL_INTERVAL = 20000;

export default function MaintenanceOverlay() {
  const [active, setActive] = useState(false);

  useEffect(() => {
    let interval;

    const check = async () => {
      try {
        const res = await fetch(`${API_URL}/api/downtime`);
        if (res.ok) {
          const data = await res.json();
          setActive(data.active);
        }
      } catch {
        // Backend unreachable - don't show overlay
      }
    };

    check();
    interval = setInterval(check, POLL_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  if (!active) return null;

  return (
    <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="sm:max-w-lg w-[90%] overflow-hidden rounded-lg border border-gray-200 dark:border-neutral-800 bg-white dark:bg-neutral-900 shadow-lg">
        <div className="relative w-full h-64 bg-amber-50 dark:bg-amber-950/30 overflow-hidden flex items-center justify-center">
          <div className="animate-modal-zoom flex flex-col items-center gap-4">
            <div className="w-20 h-20 rounded-full bg-amber-100 dark:bg-amber-900/50 flex items-center justify-center">
              <Wrench className="w-10 h-10 text-amber-500" />
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse" />
              <span className="text-sm font-medium text-amber-600 dark:text-amber-400 tracking-wide uppercase">
                Working on some changes
              </span>
              <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse" />
            </div>
          </div>
        </div>

        <div className="px-6 pb-6 pt-4 space-y-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
              Clara will be down for some time
            </h2>
            <p className="text-sm text-gray-600 dark:text-neutral-400 mt-2">
              We are working on some changes.
            </p>
          </div>

          <p className="text-sm text-gray-700 dark:text-neutral-300 text-center pt-1">
            Thank you for your patience! :D
          </p>

          <div className="flex items-center justify-center gap-1.5 pt-2">
            <span className="w-2 h-2 rounded-full bg-amber-500 animate-bounce [animation-delay:0ms]" />
            <span className="w-2 h-2 rounded-full bg-amber-500 animate-bounce [animation-delay:150ms]" />
            <span className="w-2 h-2 rounded-full bg-amber-500 animate-bounce [animation-delay:300ms]" />
          </div>
        </div>
      </div>
    </div>
  );
}
